import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { HeaderProvider } from './contexts/HeaderContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { FavoritesCountProvider } from './contexts/FavoritesCountContext';
import { InboxUnreadProvider } from './contexts/InboxUnreadContext';
import AppRoutes from './routes/AppRoutes';
import CookieConsentBanner from './components/CookieConsentBanner';
import PrairiSignalsExitPopup from './components/PrairiSignalsExitPopup';
import ScrollToTop from './components/ScrollToTop';
import { initFirebaseAnalytics } from './utils/analytics';
import { reportFirebaseConfigMismatchIfNeeded } from './utils/detectFirebaseConfigMismatch';

function App() {
  // Ensure favicon is always loaded from origin root (cache-bust so /login shows unicorn, not cached React icon)
  useEffect(() => {
    const href = `${window.location.origin}/favicon.ico?v=unicorn`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = href;
  }, []);

  useEffect(() => {
    void initFirebaseAnalytics();
    reportFirebaseConfigMismatchIfNeeded();
  }, []);

  return (
    <AuthProvider>
      <HeaderProvider>
        <FavoritesCountProvider>
          <InboxUnreadProvider>
            <ProfileProvider>
              <Router>
                <div className="App min-h-screen bg-dark-950 flex flex-col">
                  <ScrollToTop />
                  <AppRoutes />
                  <CookieConsentBanner />
                  <PrairiSignalsExitPopup />
                </div>
              </Router>
            </ProfileProvider>
          </InboxUnreadProvider>
        </FavoritesCountProvider>
      </HeaderProvider>
    </AuthProvider>
  );
}

export default App;
